module.exports = __webpack_public_path__ + "img/badge_gray_fia-cost.b0008a0d.svg";